module.exports = __webpack_public_path__ + "26ec5d20f8d4a9b83beadbed21a7d23d.MP3";